<template>
    <!-- <HeaderComponent v-if="!$route.meta.hideMenu"></HeaderComponent> -->
    <HeaderComponent :moduleName="'Indicadores'" :buildMode="envMode" />
    <main id="main">
        <section>
            <router-view />
        </section>
    </main>
    <br>
</template>

<script>
// import HeaderComponent from './assets/HeaderComponent.vue';
import { HeaderComponent } from 'roboflex-thalamus-componentes-vue3-lib'

export default {
    components: {
        HeaderComponent,
    }
}

</script>

<style>
*::-webkit-scrollbar {
    max-width: 10px;
}

*::-webkit-scrollbar-thumb {
    background-color: var(--cor-separador);
    border-radius: 20px;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>